export class SlackConfiguration {
  constructor(readonly clientId: string, readonly slackScope: string) { }
}
